import { FC, useState } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { TSCardChevronRight } from '../../components/shared/card/Card';
import { Icon } from '../../components/shared/icons/Icon';
import { ConfirmDialog } from '../../components/shared/modal/ConfirmDialog';
import { handleMutationResult } from '../../helpers/toastHelper';
import { useDeleteLocationMutation } from '../../services/gql/graphql.generated';
import strings from './manageLocation.translations';

interface DeleteLocationCardProps {
  locationId: number;
}

// TODO - remove this component once admin manage locations is fully implemented.

export const DeleteLocationCard: FC<DeleteLocationCardProps> = ({ locationId }) => {
  const [{ fetching }, deleteLocation] = useDeleteLocationMutation();

  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  const onDelete = async () => {
    const result = await deleteLocation({ id: locationId });

    await handleMutationResult(result, {
      successMessage: "Location successfully deleted.",
      errorMessage: "Unable to delete location.",
      onSuccess: () => navigate('/manage-organisation')
    });
  };

  return (
    <>
      <TSCardChevronRight
        onClick={() => setModalOpen(true)}
        icon={<Icon Icon={FiAlertTriangle} theme="red" />}
        title={strings.deleteLocationCard.title}
        description={strings.deleteLocationCard.description}
        largeHeader
      />
      <ConfirmDialog
        title={strings.deleteLocationCard.title}
        confirmLabel={strings.common.delete}
        cancelLabel={strings.common.cancel}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={onDelete}
        loading={fetching}
      >
        {strings.deleteLocationCard.confirmation}
      </ConfirmDialog>
    </>
  );
};
